import { render } from "./RelatedCaseStudiesSection.vue?vue&type=template&id=77ed574e"
import script from "./RelatedCaseStudiesSection.vue?vue&type=script&lang=js"
export * from "./RelatedCaseStudiesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/sections/RelatedCaseStudiesSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77ed574e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77ed574e', __exports__)) {
    api.reload('77ed574e', __exports__)
  }
  
  module.hot.accept("./RelatedCaseStudiesSection.vue?vue&type=template&id=77ed574e", () => {
    api.rerender('77ed574e', render)
  })

}


export default __exports__